<div class="border-card border-0 px-4 py-1 scroll-container" ref="ViewEntityType">
  <div class="d-flex justify-content-between align-items-center mb-1 me-4">
    <NavigationBackButton/>
    <span class="project-badge text-xs p-0 d-inline-flex align-items-center">
      <i class='bx bxs-bookmark-alt fs-5 me-1 text-primary-blue'></i>
      Entity Type / <span class="fw-bold p-1">  {{ entity_type_name  }}</span>
    </span>
  </div>
  <div class="card-header card-header-primary card-nav-tabs border shadow rounded-lg mt-2">
      <div class="nav-tabs-navigation p-1">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs border-bottom mb-3 " data-tabs="tabs">
            <li class="border rounded-lg me-2 nav-item mb-3" v-for="(tab, index) in tabs" :key="index"
              :class="[ active_tab === tab ? 'active' : 'inactive' ]" @click="set_active_tab(tab)">
              <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                {{ tab }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <div class="card rounded-lg border-0 shadow mt-2">
    <div class="card-body rounded-lg">
      <div v-if="active_tab === 'Fields Required' ">
        <EntityTypeAttributes :entity_type_id="entity_type_id" />
      </div>
      <div v-if="active_tab === 'Forms'">
        <CreateForms/>
      </div>

      <div v-if="active_tab === 'Template'">
        <p class="mt-2 fw-bold text-xs">Assigned Templates</p>
        <div class="d-flex justify-content-end align-items-center mb-2">
        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="redirect_to_upload_template">
          Upload template
        </button>
      </div>

        <div class="card rounded-lg shadow-sm border table-border-color p-3">
          <div class="table-responsive text-xs">
            <table id="manage-template-table" :key="'template-table-' + manage_template.length"
                  class="table table-hover w-100">
              <thead class="custom-header">
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Template Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">File Type</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Uploaded By</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Date Uploaded</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Date Modified</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start w-25">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(template, index) in manage_template" :key="index">
                  <td class="text-xxs text-start ps-3">{{ template.template_name }}</td>
                  <td class="text-xxs text-start">{{ template.file_type }}</td>
                  <td class="text-xxs text-start">{{ template.uploaded_by }}</td>
                  <td class="text-xxs text-start">{{ template.date_uploaded }}</td>
                  <td class="text-xxs text-start">{{ template.date_modified }}</td>
                  <td class="text-xxs text-start">
                    <div class="d-flex flex-nowrap">
                      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                        @click="select_template(template, 'view')">
                        View
                      </button>
                      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2"
                        data-bs-toggle="modal" data-bs-target="#update_trust_template"
                        @click="select_template(template)">
                        Update
                      </button>
                      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                        @click="configure_template(template.id)">
                        Configure
                      </button>
                      <button
                        @click="select_entity_type_template(template.id)"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                        data-bs-toggle="modal" data-bs-target="#assign_workflow">
                        Workflow
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="!loading_templates && manage_template.length === 0" class="text-center py-1 text-xxs">
            No assigned templates available. <a href='/view_template' class="text-primary-blue">Assign templates</a>
            to get started!
          </div>

          <div v-if="loading_templates" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="active_tab === 'Approval Rules'">
        <div class="text-center py-4">
          <ManageApprovalRules />
        </div>
      </div>

      <div v-if="active_tab === 'Invoice Steps'">
        <InvoiceSteps />
      </div>

      <div v-if="active_tab === 'Compliance'">
        <ComplianceRules />
      </div>

      <div v-if="active_tab === 'Sub-Entities'">
        <AssignedSubEntities />
      </div>
      <div v-if="active_tab === 'Widgets'">
        <WidgetManagement :entity_type_id="entity_type_id" />
      </div>
    </div>
  </div>
</div>

<!-- View Template Modal -->
<div v-if="preview_modal" @click.self="preview_modal = false">
    <FilePreviewComponent
      :presigned_url="selected_template.presigned_url"
      @close="close_the_file_preview"
      :key="selected_template.presigned_url"
    />
  </div>

<!-- Update Template Modal -->
<teleport to="body">
<div class="modal fade" id="update_trust_template" tabindex="-1" aria-labelledby="update_trust_template_label"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 custom-header shadow-lg">
        <h5 class="modal-title text-xxs" id="update_template_label">
          Update Template
        </h5>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

        <div class="modal-body">
          <div class="mb-3">
            <label for="update_template_name" class="modal-form-label form-label text-xxs">Template name</label>
            <input v-model="selected_template.template_name"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" type="text"
              placeholder="Trust deed template" />
          </div>

          <div class="mb-3">
            <label for="update_template_file" class="modal-form-label form-label text-xxs">Upload new template</label>
            <input class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" id="update_template_file"
              type="file" @change="handle_file_selection" />
          </div>
        </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark text-xxs btn-sm shadow-sm" @click="update_template"
          data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Workflow Modal -->
<teleport to="body">
<div class="modal fade" id="assign_workflow" tabindex="-1" aria-labelledby="assign_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_workflow_label">Assign Workflow</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <GlobalTable
          v-if="workflows.length > 0"
          :headers="workflows_table_headers"
          :data="workflows"
          :key="workflows"
          table_id="workflow_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.id"
                :checked="assigned_workflow.includes(row.id)"
                @change="toggle_assignment(row.id)"
              >
              <label class="form-check-label" :for="'switch_' + row.id">
                {{ assigned_workflow.includes(row.id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>
</div>
</teleport>